import { Component, OnInit, Directive, Inject, AfterViewInit, ViewChild, ElementRef, AfterViewChecked, OnDestroy, DOCUMENT } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { config } from '../../app.config';
import { LoginService } from './login.service';
import { AppComponent } from './../../app.component';
import { SocketService } from './../../socket/socket.service';
import { AlertPopup, HttpLoader } from './../../app.config';
import { ValidationService } from '../form-validation/validation.service';
import { DataSharingService } from 'app/shared/data-sharing.service';
import { AssistBotService } from '../ai-assist/assist-bot.service';
import { LlmService } from 'app/services/llm.service';
import { HttpErrorResponse } from '@angular/common/http';

import { HeaderService } from '../header/header.service';
import { UserService } from '../userandgroup/user/user.service';
import { IndexedDBService } from 'app/services/indexed-db.service';
import { TtstreamService } from 'app/services/ttstream.service';
import { DotLottie } from "@lottiefiles/dotlottie-web";
import { finalize } from 'rxjs';

export function validateExternalParams(params: any) {
  try {

    const acKey = params?.acKey;

    if (!acKey) {
      return null;
    }

    const decoded = decodeURIComponent(acKey);

    const parts = decoded.split('-');

    if (parts.length < 3) {
      return null;
    }

    const id = parts[0];
    const mxId = parts[1];
    const payload = parts.slice(2).join('-');

    return {
      id,
      mxId,
      payload
    };

  } catch (e) {
    console.error('Param decode error:', e);
    return null;
  }
}

// @Directive()
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false
})

export class LoginComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {

  @ViewChild("dotCanvas") dotCanvas!: ElementRef<HTMLCanvasElement>;


  loginForm: FormGroup;
  showBtnSpinner = false;
  showSpinner = false;
  loginErrMsg: string = "";
  copyRights: number = config.copyrights;
  show: boolean = false;
  isloginBtnShow = false;
  hostlogo: any;
  validExternalParams: { clientId: string, token: string } | null = null;
  autoLoginInProgress = false;
  loginAnimation: DotLottie | undefined;
  loginFormVisible = true;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly fb: FormBuilder,

    private readonly loginService: LoginService,
    private readonly userService: UserService,
    private readonly llmService: LlmService,

    private readonly socketService: SocketService,
    private readonly botService: TtstreamService,
    private readonly assistBotService: AssistBotService,

    private readonly loader: HttpLoader,
    private readonly alert: AlertPopup,
    private readonly headerService: HeaderService,

    private readonly indexedDBService: IndexedDBService,
    private readonly dataSharingService: DataSharingService,

    private readonly app: AppComponent,

    @Inject(DOCUMENT)
    private readonly document: Document

  ) {

    this.loginForm = this.fb.group({

      email_id: [
        '',
        [
          Validators.required,
          ValidationService.emailValidator
        ]
      ],

      password: [
        {
          value: '',
          disabled: true
        }
      ]

    });

  }

  ngOnInit(): void {
    this.route.queryParams.subscribe({
      next: (params) => {
        try {
          const { acKey, isAB } = params;

          console.log('acKey:', acKey);
          console.log('isAB:', isAB);

          if (!acKey) {
            this.autoLoginInProgress = false;
            console.warn('Invalid acKey');
            return;
          }

          this.autoLoginInProgress = true;

          // Query params are strings
          const isABUser = isAB === 'true';

          if (isABUser) {
            this.loginSSOABSP(acKey);
          } else {
            this.loginSSOEDA(acKey);
          }

        } catch (error) {
          console.error('Parameter validation error:', error);
          this.autoLoginInProgress = false;
        }
      },
      error: (err) => {
        console.error('Query param error:', err);
        this.autoLoginInProgress = false;
      }
    });
  }



  showHidePassword() {
    this.show = !this.show;
  }


  clearLocalStorage() {
    window.localStorage.clear();
  };

  /**
   * User Authentication Email Verified Function
   * @param formValue
   */

  authenticateEmailVerify(formValue: any): void {

    this.showSpinner = true;
    this.loader.showLoader();

    this.loginService.authenticateEmail(formValue)
      .pipe(
        finalize(() => {
          this.showSpinner = false;
          this.loader.hideLoader();
        })
      )
      .subscribe({
        next: (response: any) => {

          if (response?.data?.acc_active) {

            this.isloginBtnShow = true;

            const passwordControl = this.loginForm.get('password');

            passwordControl?.setValidators([
              Validators.required,
              ValidationService.passwordValidate
            ]);

            passwordControl?.enable();
            passwordControl?.updateValueAndValidity();

          } else {
            this.isloginBtnShow = false;
            this.alert.showErrorMessage('Your account has been deactivated');
          }
        },

        error: (error: any) => {
          this.alert.showErrorMessage(
            error?.error?.message || 'Something went wrong'
          );
        }
      });
  }

  private showError(message: string): void {

    this.loginErrMsg = message;

    setTimeout(() => {

      this.loginErrMsg = '';

    }, 3000);

  }

  /**
   * User Authentication Function
   * @param formValue
   */

  authenticateUser(formValue: any): void {
    this.showBtnSpinner = true;
    this.loader.showLoader();

    this.loginService.authenticateUser(formValue)
      .pipe(
        finalize(() => {
          this.showBtnSpinner = false;
          this.loader.hideLoader();
        })
      )
      .subscribe({
        next: (user: any) => {
          if (!user) {
            this.alert.showErrorMessage('Invalid login response');
            return;
          }

          localStorage.setItem('user_id', JSON.stringify(user.user_id));
          localStorage.setItem('user_role', JSON.stringify(user.user_role));
          localStorage.setItem('token', JSON.stringify(user.token));
          localStorage.setItem('company_id', JSON.stringify(user.company_id));
          localStorage.setItem('work_state', JSON.stringify(user.work_state));
          localStorage.setItem('employer_code', JSON.stringify(user.employer_code));

          const payload = {
            client_id: user.company_id,
            user_id: user.user_id
          };

          this.loginLLM(payload, user.user_role);
        },

        error: (err: any) => {
          this.alert.showErrorMessage(err?.error?.message || 'Login failed');
        }
      });
  }



  removeErrMsg() {
    this.loginErrMsg = "";
  }

  ngAfterViewInit() {
    this.llmService.llmRunningStarus().subscribe({
      next: (res: any) => {

      }, error: (error: HttpErrorResponse) => {

        this.alert.showAlertMessage({ "message": "AI Model not running currently" });
        // (<HTMLElement> this.document.getElementsByClassName("login-btn")[0]).style.display='none';

      }
    });

    if (this.autoLoginInProgress) {
      this.initAnimation();
    }
  }

  initAnimation() {
    if (!this.dotCanvas) {
      console.warn("Canvas still not available, delaying...");
      setTimeout(() => this.initAnimation(), 50);
      return;
    }

    this.loginAnimation = new DotLottie({
      autoplay: true,
      loop: true,
      canvas: this.dotCanvas.nativeElement,
      src: "assets/json/loading-animation.json",
    });
  }

  ngAfterViewChecked() {
    if (this.autoLoginInProgress && !this.loginAnimation) {
      this.loadAnimation();
    }
  }

  loadAnimation() {
    const canvasElement = document.querySelector(
      "#dotlottie-canvas",
    ) as HTMLCanvasElement;
    if (canvasElement) {
      this.loginAnimation = new DotLottie({
        autoplay: true,
        loop: true,
        canvas: canvasElement,
        src: "assets/json/loading-animation.json",
      });
    } else {
      console.error("Canvas element not found!");
    }
  }

  //Absence Blueprint auto login
  loginSSOABSP(ackey: any) {

    const payload = {
      token: ackey,
      verifier: 'sampleTestKey'
    }

    this.loginService.autoLoginAbsenceBlueprint(payload).subscribe({
      next: (user: any) => {
        this.alert.showAlertMessage({ 'message': 'User logged successfully...' });

        this.loader.hideLoader();
        this.showBtnSpinner = false;

        localStorage.setItem('user_id', JSON.stringify(user.user_id));
        localStorage.setItem('user_role', JSON.stringify(user.user_role));
        localStorage.setItem('token', JSON.stringify(user.token));
        localStorage.setItem('company_id', JSON.stringify(user.company_id));
        localStorage.setItem('work_state', JSON.stringify(user.work_state));
        localStorage.setItem('employer_code', JSON.stringify(user.employer_code));

        const payload = {
          client_id: localStorage.getItem('company_id'),
          user_id: localStorage.getItem('user_id')
        };

        const userRole = localStorage.getItem('user_role');

        this.loginLLM(payload, userRole);

      },
      error: (error) => {
        this.alert.showAlertMessage({ 'message': 'Invalid details. Please try again' });
        this.autoLoginInProgress = false;

        const errMsg = JSON.stringify(error.error["message"]).replace(
          /['"]+/g,
          "",
        );
        console.log(errMsg);
        this.loginErrMsg = errMsg;

        setTimeout(() => {
          this.loginErrMsg = "";
        }, 2500);

        this.router.navigate(['/login']);
        this.loginForm.get("password")?.setValue("");


        this.showBtnSpinner = false;
        this.loader.hideLoader();

      }
    })
  }

  //Login EDA SSO
  loginSSOEDA(ackey: any) {
    const payload = {
      token: ackey,
      verifier: 'ngeda_verify_06f21c139aeeead453b6570759d82c7279efceab'
    }
  }

  redirectToforgetpass(): void {

    const forgotMail = this.loginForm.get('email_id')?.value?.trim();

    if (!forgotMail) {

      this.loginErrMsg = 'Please enter your email address';

      setTimeout(() => {

        this.loginErrMsg = '';

      }, 3000);

      return;

    }

    this.dataSharingService.emitgetForgotMailId(forgotMail);

    sessionStorage.setItem('email_id', forgotMail);

    this.router.navigate(['/forgot_password']);

  }



  private loginLLM(payload: any, userRole: any): void {

    this.llmService.llmUserLogin(payload).subscribe({

      next: (response: any) => {

        this.handleLLMLoginSuccess(response, userRole);

      },

      error: (err: any) => {

        if (
          err.status === 401 ||
          err.error?.message === 'User not found or inactive'
        ) {

          this.createLLMUser(payload, userRole);

        } else {

          console.error('LLM Login Error', err);

          this.finishLogin(userRole);

        }

      }

    });

  }

  private createLLMUser(payload: any, userRole: any): void {

    this.llmService.llmCreateUser(payload).subscribe({

      next: () => {

        this.loginLLM(payload, userRole);

      },

      error: (err: any) => {

        console.error('Create LLM User Error', err);

        this.finishLogin(userRole);

      }

    });

  }

  private handleLLMLoginSuccess(response: any, userRole: any): void {

    if (response?.token) {
      localStorage.setItem('llm_token', response.token);
    }

    this.llmService.LLM_classes = response?.class_access || [];

    this.finishLogin(userRole);
  }

  private finishLogin(role: any) {

    const userRole = JSON.parse(role || '""');

    this.loadUserData();

    if (userRole === '4' || userRole === 4) {
      this.router.navigate(['/maps']);
    } else {
      this.router.navigate(['/dashboard']);
    }
  }


  private loadUserData(): void {

    this.app.getCurrentUserData();

    this.app.getUserStatusData();

  }

  redirectTosignup() {
    this.router.navigate(['/signup']);
  };

  ngOnDestroy(): void {
    // this.loadAnimation?.destroy();
  }

}



